---
nb:
  users:
    flash_account_disabled: Kontoen er deaktivert. Kontakt support.
    flash_account_locked: Kontoen er låst. Kontakt support.
    flash_account_updated: Konto oppdatert
    flash_password_reset_instructions: Vi vil sende en e-post hvis vi finner kontoen knyttet til denne e-posten
    flash_password_sent: Et nytt passord har blitt sendt til
    form:
      clear_companies_confirm: Dette fjerner brukerens tilgang til alle selskapene i listen når du lagrer.
      clear_power_plants_confirm: Dette fjerner brukerens tilgang til alle kraftverkene i listen når du lagrer.
      unlisted_companies: Har også tilgang til ett selskap du ikke kan tildele. Det beholdes når du lagrer. | Har også tilgang til {count} selskaper du ikke kan tildele. De beholdes når du lagrer.
      unlisted_power_plants: Har også tilgang til ett kraftverk du ikke kan tildele. Det beholdes når du lagrer. | Har også tilgang til {count} kraftverk du ikke kan tildele. De beholdes når du lagrer.
    locales:
      de: DE
      en: EN
      fr: FR
      nb: 'NO'
    password_notice: La passordfeltet stå tomt for å beholde passordet uendret
    users: Brukere
